import { CardContent, Divider, Stack, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomBtnFilled from "../../atoms/form-molecules/CustomBtnFilled";


interface AgendaHeaderProps {
  showArchived: boolean;
  onToggleArchived: () => void;
  selectedIndex?: number;
  totalCount?: number;
  showToggleBtn?: boolean;
  ComponentForExtraInfo?: React.ReactNode;
}

const AgendaHeader: React.FC<AgendaHeaderProps> = ({
  showArchived,
  onToggleArchived,
  selectedIndex,
  totalCount,
  showToggleBtn = true,
  ComponentForExtraInfo= <></>
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
  <CardContent sx={{ pb: 1, flexShrink: 0 }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} mb={isMobile ? 0 : 2}>
      <Typography fontSize="16px" fontWeight={600}>
        {showArchived ? "Responded Agendas" : "Pending Agendas"}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1}>
        {ComponentForExtraInfo}
        {selectedIndex !== undefined && totalCount && (
          <Typography variant="caption" color="text.secondary">
            {selectedIndex + 1} of {totalCount}
          </Typography>
        )}
        {showToggleBtn && (
          <Tooltip arrow title={showArchived ? "Show Pending Agendas" : "Show Responded Agendas"}>
          <span>
            <CustomBtnFilled
              variant={showArchived ? "contained" : "outlined"}
              onClick={onToggleArchived}
              label={showArchived ? "Pending" : "Responded"}
            />
          </span>
        </Tooltip>
        )}
      </Stack>
    </Stack>
    {!isMobile &&<Divider />}
  </CardContent>
)
};

export default AgendaHeader;